/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const FilmstripContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const FlexContainer = styled.div`
  justify-content: center;
  display: flex;
`;
